
//import * as api from '@/api/index.js';
import { defineComponent, onMounted, reactive, Ref, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import i18n from "@/locale";
import API from "@/apis/TPSAPI";
import { useUserInfoStore } from "@/stores/UserInfoStore";
import { IonIcon } from "@ionic/vue";
import { personCircleOutline, globeOutline, logOutOutline, menuOutline } from "ionicons/icons";
import { LocaleType } from "@/models/enums/LocaleType";

//import { useStore} from 'vuex';
export default defineComponent({
  name: "header-component",
  components: { IonIcon },
  emits: ["OnHamburgerClicked"],
  setup() {
    const t = i18n.global.t;
    const router = useRouter();
    const userInfoStore = useUserInfoStore();
    const state = reactive({
      username: "",
      langTooltipDisabled: true,
    });

    //#region 建立表單ref與Validator
    //#endregion

    //#region Hook functions
    onMounted(async () => {
      //套用顯示語系
      let lang = userInfoStore.getLocale();
      userInfoStore.setLocale(lang);
    });
    //#endregion

    //#region UI Events
    /** 按下登出 */
    const onLogoutClicked = async () => {
      try {
        await API.logout();
      } catch (error) {
        console.log(error);
        return;
      }
      userInfoStore.clearToken();

      router.replace({ path: "/Login" });
    };

    /** 選擇語言 */
    const onLangSelectChanged = async (lang: LocaleType) => {
      userInfoStore.setLocale(lang);
    };

    //#endregion

    //#region Private Functions
    //#endregion

    return {
      ...toRefs(state),
      t,
      LocaleType,
      userInfoStore,
      personCircleOutline,
      globeOutline,
      logOutOutline,
      menuOutline,
      onLangSelectChanged,
      onLogoutClicked,
    };
  },
});
